"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var warning_svg_1 = __importDefault(require("../../../res/img/warning.svg"));
exports.default = (function (props) { return (react_1.default.createElement("div", { className: "info-row flex flex-row", "data-negative": props.negativeValue },
    react_1.default.createElement("div", { className: "info-row__label" },
        props.label,
        props.duplicate !== null && props.duplicate !== undefined ?
            react_1.default.createElement("div", { className: "duplicate-warning" },
                react_1.default.createElement("img", { src: warning_svg_1.default, alt: "Warning" }),
                react_1.default.createElement("div", { className: "text" },
                    react_1.default.createElement("p", null,
                        "A query with this reference already exists with the log number: ",
                        react_1.default.createElement("b", null, props.duplicate))))
            :
                null),
    react_1.default.createElement("div", { className: "info-row__value" }, props.value))); });
